import * as React from "react"

/** React hook to generate unique identifiers that conditionally share a prefix. */
export const useUuid = <T extends string>(prefix: string = "") => {
  const uuid = React.useId()
  const mix = (part: string) => prefix + part + uuid

  return React.useCallback((...parts: T[]) => parts.map(mix).join(" "), [uuid])
}

export namespace useUuid {
  export type ReturnType = <T extends string>(...parts: T[]) => string
}

export const createUuidContext = () => {
  const UuidContext = React.createContext(null as any as (...parts: string[]) => string)

  const UuidProvider = ({ prefix, ...props }: React.PropsWithChildren<{ prefix: string }>) => {
    const value = useUuid(prefix)

    return React.createElement(UuidContext.Provider, {
      value,
      ...props,
    })
  }

  const useUuidContext = () => React.useContext(UuidContext)

  return [UuidProvider, useUuidContext] as const
}
